/**
 * Loading Spinner Component
 * 
 * Consistent loading indicator used throughout the application
 */

/**
 * Loading Spinner
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message
 * @param {string} [props.size] - Size: 'sm', 'md', 'lg' (default: 'md')
 * @param {boolean} [props.fullScreen] - Whether to show full screen overlay
 */
export default function LoadingSpinner({ 
  message = 'Loading...', 
  size = 'md',
  fullScreen = false 
}) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  const spinnerSize = sizeClasses[size] || sizeClasses.md

  const content = (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className={`animate-spin rounded-full border-b-2 border-primary ${spinnerSize}`}></div>
      {message && (
        <p className="text-slate-600 dark:text-slate-400 text-sm font-medium">
          {message}
        </p>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm z-50 flex items-center justify-center">
        {content}
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center py-8">
      {content}
    </div>
  )
}

/**
 * Inline Loading Spinner (small, no message)
 */
export function InlineSpinner({ size = 'sm', className = 'border-primary' }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  }

  return (
    <div className={`animate-spin rounded-full border-b-2 ${className} ${sizeClasses[size]}`}></div>
  )
}
